import paymentMasterService from "@services/master-data/paymentMasterService"
import { action, makeAutoObservable, observable } from "mobx"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"

class PaymentMasterStore {
  @observable isLoading!: boolean
  @observable listDataPhase!: any
  @observable listDataPeriod!: any
  @observable tableDataPhase!: PagedResultDto<any>
  @observable tableDataPeriod!: PagedResultDto<any>
  @observable detailDataPhase!: any
  @observable detailDataPeriod!: any

  constructor() {
    makeAutoObservable(this)
    this.listDataPhase = []
    this.listDataPeriod = []
    this.tableDataPhase = { items: [], totalCount: 0 }
    this.tableDataPeriod = { items: [], totalCount: 0 }
    this.detailDataPhase = {}
    this.detailDataPeriod = {}
  }

  @action
  async createOrUpdatePhase(body: any) {
    await paymentMasterService.createOrUpdatePhase(body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
  }
  @action
  async activatePhase(id: number, isActive) {
    await paymentMasterService.activatePhase(id, isActive)
  }
  @action
  async getListPhase(params: any) {
    this.isLoading = true
    const result = await paymentMasterService
      .getListPhase(params)
      .finally(() => (this.isLoading = false))
    this.listDataPhase = result
  }

  @action
  async getAllPhase(params: any) {
    this.isLoading = true
    const result = await paymentMasterService
      .getAllPhase(params)  
      .finally(() => (this.isLoading = false))
    this.tableDataPhase = result
  }

  @action
  async getPhase(id: number) {
    this.isLoading = true
    const result = await paymentMasterService
      .getPhase(id)
      .finally(() => (this.isLoading = false))
    this.detailDataPhase = result
  }

  // period
  @action
  async createOrUpdatePeriod(body: any) {
    await paymentMasterService.createOrUpdatePeriod(body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
  }
  @action
  async activatePeriod(id: number, isActive) {
    await paymentMasterService.activatePeriod(id, isActive)
  }
  @action
  async getListPeriod(params: any) {
    this.isLoading = true
    const result = await paymentMasterService
      .getListPeriod(params)
      .finally(() => (this.isLoading = false))
    this.listDataPeriod = result
  }

  @action
  async getAllPeriod(params: any) {
    this.isLoading = true
    const result = await paymentMasterService
      .getAllPeriod(params)
      .finally(() => (this.isLoading = false))
    this.tableDataPeriod = result
  }

  @action
  async getPeriod(id: number) {
    this.isLoading = true
    const result = await paymentMasterService
      .getPeriod(id)
      .finally(() => (this.isLoading = false))
    this.detailDataPeriod = result
  }
}

export default PaymentMasterStore
